import { usePopup } from 'app/hooks/utils/popup';
import { Diagnosis } from 'lib/models/diagnoses/diagnosis';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { LuEye } from 'react-icons/lu';
import { SearchQueryProps } from '../props';

/**
 * Props for a selected symptom item component.
 */
type ExcludedDiagnosesListProps = {
  items: Diagnosis[];
  form: UseFormReturn<SearchQueryProps, any, undefined>;
};

/**
 * Props for a selected symptom item component.
 */
type ExcludedDiagnosesListItemProps = {
  diagnosis: Diagnosis;
  form: UseFormReturn<SearchQueryProps, any, undefined>;
};

/**
 * List of selected symptoms (which may be highlighted).
 */
export const ExcludedDiagnosesList: React.FC<ExcludedDiagnosesListProps> = ({
  items,
  form
}) => {
  return (
    <ul>
      {items.map((item) => (
        <ExcludedDiagnosesListItem key={item.id} diagnosis={item} form={form} />
      ))}
    </ul>
  );
};

/**
 * A selected symptom item in a list.
 */
export const ExcludedDiagnosesListItem: React.FC<ExcludedDiagnosesListItemProps> = ({
  diagnosis,
  form
}) => {
  // Enable popups support
  const { enqueuePopup } = usePopup();

  // Variables
  const synonyms =
    diagnosis.synonyms.length > 0 ? diagnosis.synonyms.join(', ') : undefined;

  return (
    <li>
      <span className="selection-name" title={synonyms}>
        {diagnosis.name}
      </span>
      <button
        className="button button-xs button-secondary opacity-50"
        onClick={() => {
          const newList = [...form.getValues().excludedDiagnoses].filter(
            (item) => item.id !== diagnosis.id
          );
          form.setValue('excludedDiagnoses', newList);
        }}
        title={`Include diagnosis back into the search results`}
      >
        <LuEye />
      </button>
    </li>
  );
};
